import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { GruposPoblacionBeneficiarioDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class GruposPoblacionBeneficiarioService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getGruposPoblacionBeneficiarioService(): Observable<
    BodyListResponse<GruposPoblacionBeneficiarioDTO>
  > {
    return this.http.get<BodyListResponse<GruposPoblacionBeneficiarioDTO>>(
      API_URL + '/api/v1/gruposPoblacionBeneficiario/todos',
    );
  }

  guardarGruposPoblacionBeneficiarioService(
    gruposPoblacionBeneficiarioDTO: GruposPoblacionBeneficiarioDTO,
  ): Observable<BodyResponse<GruposPoblacionBeneficiarioDTO>> {
    return this.http.post<BodyResponse<GruposPoblacionBeneficiarioDTO>>(
      API_URL + '/api/v1/gruposPoblacionBeneficiario',
      gruposPoblacionBeneficiarioDTO,
    );
  }

  getGruposPoblacionBeneficiarioPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<GruposPoblacionBeneficiarioDTO>> {
    return this.http.get<BodyResponse<GruposPoblacionBeneficiarioDTO>>(
      API_URL + '/api/v1/gruposPoblacionBeneficiario/' + codigo,
    );
  }
}
